import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../services/api';
import './ConsentForm.css';

function ConsentForm({ onComplete, onNext }) {
  const { t } = useTranslation();
  const [materialsConsent, setMaterialsConsent] = useState(false);
  const [metaAccountsConsent, setMetaAccountsConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!materialsConsent || !metaAccountsConsent) {
      setError(t('onboarding.consent.all_required'));
      return;
    }

    try {
      setSubmitting(true);
      setError(null);

      await apiClient.post('/api/v1/onboarding/consent', {
        voice_consent: true, // Already given in voice step
        materials_consent: materialsConsent,
        meta_accounts_consent: metaAccountsConsent,
      });

      onComplete();
      onNext();
    } catch (err) {
      console.error('Error saving consent:', err);
      setError(err.response?.data?.detail || t('onboarding.errors.save_consent_failed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="consent-form">
      <div className="consent-header">
        <h2>{t('onboarding.consent.title')}</h2>
        <p>{t('onboarding.consent.description')}</p>
      </div>

      <form onSubmit={handleSubmit} className="consent-form-content">
        <div className="consent-item">
          <div className="consent-item-header">
            <h3>{t('onboarding.consent.materials.title')}</h3>
          </div>
          <p className="consent-description">
            {t('onboarding.consent.materials.description')}
          </p>
          <label className="consent-checkbox">
            <input
              type="checkbox"
              checked={materialsConsent}
              onChange={(e) => setMaterialsConsent(e.target.checked)}
            />
            <span>{t('onboarding.consent.materials.checkbox')}</span>
          </label>
        </div>

        <div className="consent-item">
          <div className="consent-item-header">
            <h3>{t('onboarding.consent.meta_accounts.title')}</h3>
          </div>
          <p className="consent-description">
            {t('onboarding.consent.meta_accounts.description')}
          </p>
          <label className="consent-checkbox">
            <input
              type="checkbox"
              checked={metaAccountsConsent}
              onChange={(e) => setMetaAccountsConsent(e.target.checked)}
            />
            <span>{t('onboarding.consent.meta_accounts.checkbox')}</span>
          </label>
        </div>

        {error && <div className="error-message">{error}</div>}

        <button 
          type="submit" 
          className="continue-button"
          disabled={submitting || !materialsConsent || !metaAccountsConsent}
        >
          {submitting ? t('onboarding.consent.saving') : t('onboarding.consent.continue_button')}
        </button>
      </form>
    </div>
  );
}

export default ConsentForm;

